import type { Case } from "@/lib/useRealtimeCases";
import { CreatePersonalReminder } from "@/components/reminders/CreatePersonalReminder";
import { SectionTitle } from "./SectionTitle";

interface Props {
  caseData: Case;
  onFieldChange: (field: keyof Case, value: unknown) => void;
}

/** Bloc « Rappel » : date + heure de relance téléphonique et rappel personnel. */
export function RappelBlock({ caseData, onFieldChange }: Props) {
  const date = caseData.phone_reminder_date || "";
  const time = caseData.phone_reminder_time?.slice(0, 5) || "";
  const setDate = (value: string) => {
    onFieldChange("phone_reminder_date", value || null);
    // Comme dans la fiche : vider la date vide aussi l'heure.
    if (!value) onFieldChange("phone_reminder_time", null);
  };
  const dateId = `rappel-date-${caseData.id}`;
  const timeId = `rappel-time-${caseData.id}`;

  return (
    <section aria-labelledby={`rappel-title-${caseData.id}`} className="border-b border-gray-200 px-4 py-4">
      <SectionTitle id={`rappel-title-${caseData.id}`}>Rappel</SectionTitle>
      <div className="mt-2 grid grid-cols-[minmax(0,1fr)_7.5rem] gap-2">
        <label htmlFor={dateId} className="text-xs font-medium text-gray-700">
          Relance téléphonique
          <input
            id={dateId}
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="mt-1 block w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
          />
        </label>
        <label htmlFor={timeId} className="text-xs font-medium text-gray-700">
          Heure (Paris)
          <input
            id={timeId}
            type="time"
            value={time}
            disabled={!date}
            onChange={(e) => onFieldChange("phone_reminder_time", e.target.value || null)}
            className="mt-1 block w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 disabled:bg-gray-100 disabled:text-gray-400"
          />
        </label>
      </div>
      <p className="mt-2 text-xs leading-5 text-gray-500">
        Repère pour l’équipe : la date ne remonte plus dans « À faire ». Pour être prévenu, créez un rappel.
      </p>
      <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
        <CreatePersonalReminder caseId={caseData.id} title={caseData.title || "Dossier sans titre"} />
        {date && (
          <button
            type="button"
            onClick={() => setDate("")}
            className="rounded px-1 text-xs font-medium text-gray-600 underline-offset-2 hover:text-gray-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
          >
            Effacer la date
          </button>
        )}
      </div>
    </section>
  );
}
